export default "__VITE_PUBLIC_ASSET__d5eed05f__"